import { useEffect, useRef, useState } from "react";
import { formatPrice, URL_API } from "../../utils/helper/helpers";
import axios from "axios";
import { toast } from "react-toastify";
import { Row, Col, Card, CardHeader, CardBody, Table } from "reactstrap";
import { H4, H6, H3, H2, Btn } from "../../AbstractElements";
import { formatDate, generateRandomNumber, getWeekOfMonth } from "../../utils/helper/helpers";
import { Link } from "react-router-dom";
import html2pdf from "html2pdf.js";
import React from "react";
import { Accordion, AccordionItem } from 'react-light-accordion';
import 'react-light-accordion/demo/css/index.css';




interface CaisseInterface {
    [key: string]: any;
}

const useCaisseListe = (refresh: boolean): CaisseInterface[] => {
    const [caisses, setCaisses] = useState<CaisseInterface[]>([]);
    const Token = JSON.parse(localStorage.getItem("login")!);

    useEffect(() => {
        const fetchCaisses = async () => {
            axios.get(`${URL_API}/caisse/index`, {
                headers: {
                    Authorization: `Bearer ${Token}`
                }
            }).then(response => {

                if (response.status === 201) {
                    setCaisses(response.data.caisse);
                }

            }).catch(error => {

                if (error.response.status === 400) {
                    toast.info(error.response.data.message);
                }
            })
        };

        fetchCaisses();
    }, [refresh]);
    return caisses;
};
export default useCaisseListe;

export const CardCaisse = ({ value }: { value: { [key: string]: any } }) => {
    let entre = 0;
    let entre_solde = 0;
    let sortie = 0;
    let sortie_solde = 0;
    let total = 0;
    let total_montant = 0;

    // Utilisation de `reduce` pour améliorer la lisibilité et l'efficacité
    value.forEach((item: any) => {
        const montant = Number(item.montant); // conversion sécurisée
        if (item.type === 'Entrée') {
            entre += 1;
            entre_solde += montant;
            total_montant += montant;
        } else if (item.type === 'Sortie') {
            sortie += 1;
            sortie_solde += montant;
            total_montant -= montant;
        }
    });

    return (
        <Row>
            <Col sm="4">
                <Card className="progress-items pb-0 bg-light-info">
                    <CardHeader className="pb-4 bg-light-info">
                        <div className="d-flex justify-content-between">
                            <div>
                                <H4>
                                    <span className="text-dark fw-bold">{formatPrice(total_montant)}</span>
                                </H4>
                                <H6 className="f-20 f-w-600 mt-3">
                                    Montant Actuel
                                </H6>
                            </div>
                            <div>
                                {
                                    total_montant >= 0 ? (
                                        <i className="icon-stats-up f-80"></i>
                                    ) : (
                                        <i className="icon-stats-down f-80 text-danger"></i>
                                    )
                                }
                            </div>
                        </div>
                    </CardHeader>
                </Card>
            </Col>
            <Col md="4">
                <Card className="progress-items pb-0 bg-light-success">
                    <CardHeader className="pb-4 bg-light-success">
                        <div className="d-flex justify-content-between">
                            <div>
                                <H4>
                                    <span className="text-dark fw-bold">{formatPrice(entre_solde)}</span>
                                </H4>
                                <H6 className="f-20 f-w-600 mt-3">
                                    Entrée
                                </H6>
                            </div>
                            <div>
                                <i className="icofont icofont-download-alt f-80"></i>
                            </div>
                        </div>
                    </CardHeader>
                </Card>
            </Col>
            <Col md="4">
                <Card className="progress-items pb-0 bg-light-danger">
                    <CardHeader className="pb-4 bg-light-danger">
                        <div className="d-flex justify-content-between">
                            <div>
                                <H4>
                                    <span className="text-dark fw-bold">{formatPrice(sortie_solde)}</span>
                                </H4>
                                <H6 className="f-20 f-w-600 mt-3 text-white">
                                    Sortie
                                </H6>
                            </div>
                            <div>
                                <i className="icofont icofont-upload-alt f-80"></i>
                            </div>
                        </div>
                    </CardHeader>
                </Card>
            </Col>

        </Row>
    )
};

export const SyntheseParSemaineMensuelle = ({ value }: { value: { [key: string]: any } }) => {

    const [show, setShow] = useState(true);
    const pdfRef = useRef<HTMLDivElement>(null);

    // Initialisation des totaux pour chaque semaine (maximum de 5 semaines)
    const totals = {
        entre_semaine: [0, 0, 0, 0, 0], // 5 semaines possibles
        sortie_semaine: [0, 0, 0, 0, 0],
        solde_semaine: [0, 0, 0, 0, 0],
        total_entree: 0,
        total_sortie: 0,
    };

    let month = '';
    let totalWeeks = 4; // Par défaut, un mois peut avoir 4 semaines

    // Fonction modifiée pour forcer le 1er novembre comme début de la première semaine
    const getWeekRange = (year: number, month: number, weekNumber: number) => {
        // Premier jour du mois
        const firstDayOfMonth = new Date(year, month, 1);

        // Calcul de la date de début et de fin de la semaine en forçant la première semaine à partir du 1er
        const startOfWeek = new Date(firstDayOfMonth);
        startOfWeek.setDate(startOfWeek.getDate() + (weekNumber - 1) * 7);

        // Si la date dépasse la fin du mois, ajuster
        if (startOfWeek.getMonth() !== month) {
            return null; // La semaine ne fait pas partie du mois
        }

        const endOfWeek = new Date(startOfWeek);
        endOfWeek.setDate(endOfWeek.getDate() + 6); // La fin de la semaine (7 jours après le début)

        return { start: startOfWeek, end: endOfWeek };
    };

    // Utilisation de `forEach` pour itérer sur les données
    value.forEach((item: any) => {
        const num_semaine = getWeekOfMonth(item.date_mouvement); // Fonction à définir pour obtenir le numéro de semaine
        month = new Date(item.date_mouvement).toLocaleString("fr-FR", { month: "long", year: 'numeric' });

        // Mettre à jour le nombre total de semaines en fonction du mois
        totalWeeks = Math.max(totalWeeks, num_semaine);

        // Si c'est une entrée
        if (item.type === 'Entrée') {
            totals.entre_semaine[num_semaine - 1] += Number(item.montant);
            totals.solde_semaine[num_semaine - 1] += Number(item.montant);
            totals.total_entree += Number(item.montant);
        }
        // Si c'est une sortie
        else if (item.type === 'Sortie') {
            totals.sortie_semaine[num_semaine - 1] += Number(item.montant);
            totals.solde_semaine[num_semaine - 1] -= Number(item.montant);
            totals.total_sortie += Number(item.montant);
        }
    });

    // Générer dynamiquement les lignes pour chaque semaine avec les intervalles
    const weekRows = [];
    for (let week = 0; week < totalWeeks; week++) {
        // Calculer l'intervalle de dates pour la semaine
        const { start, end } = getWeekRange(new Date().getFullYear(), new Date().getMonth(), week + 1) || { start: new Date(), end: new Date() };;

        // Formatage de la plage de dates
        const weekRange = `Du ${formatDate(start)}...`;

        // Ajout de la ligne avec le numéro de la semaine et l'intervalle
        weekRows.push(
            <tr key={week}>
                <td>
                    <div className="d-flex align-items-center gap-2">
                        <div className="flex-shrink-0">
                            <i className="icofont icofont-ui-calendar f-40 "></i>
                        </div>
                        <div className="flex-grow-1">
                            <Link to="#">
                                <H6 className="f-w-500">Semaine {week + 1}</H6>
                            </Link>
                            <span className=" text-capitalize f-w-400 f-13">  {weekRange} </span>
                        </div>
                    </div>
                </td>
                <td className="text-end">{formatPrice(totals.entre_semaine[week])}</td>
                <td className="text-end">{formatPrice(totals.sortie_semaine[week])}</td>
                <td className="text-end">{formatPrice(totals.solde_semaine[week])}</td>
            </tr>
        );
    }

    const generatePDF = () => {
        setShow(false)
        const element = pdfRef.current;
        const name_document = generateRandomNumber(100000, 999999);
        if (element) {
            html2pdf()
                .from(element)
                .save(`synthese_caisse${name_document}.pdf`)
                .then(() => setShow(true))
                .catch(() => setShow(true));
        }
    };

    return (
        <Card className="invoice-card">
            <div ref={pdfRef}>

                <CardBody className="invoice-table pt-0 checkbox-checked">
                    <H2 className="fw-bolder text-center text-uppercase mb-3 f-w-13">
                        Synthese mensuelle de la caisse. <br />
                        <span className="text-capitalize f-w-400 f-25">{month != '' ? month : new Date().toLocaleString("fr-FR", { month: "long", year: 'numeric' })}</span><br />
                        {
                            show == true ? (
                                <>
                                    <Btn color="light-dark " onClick={generatePDF} className="btn btn-xs mx-1 p-1 px-3 for-light">
                                        <i className="fa fa-download"></i> Télécharger
                                    </Btn>
                                    <Btn color="light-light " onClick={generatePDF} className="btn btn-xs mx-1 p-1 px-3 for-dark">
                                        <i className="fa fa-download"></i> Télécharger
                                    </Btn>
                                </>
                            ) : (
                                null
                            )
                        }
                    </H2>

                    <Table responsive id="all-invoice">
                        <thead className="bg-info">
                            <tr>
                                <th className="text-white ps-4">Semaine</th>
                                <th className="text-white text-end">Entrée</th>
                                <th className="text-white text-end">Sortie</th>
                                <th className="text-white text-end">Solde</th>
                            </tr>
                        </thead>
                        <tbody>
                            {weekRows}
                            <tr>
                                <td className="text-center fw-bold">TOTAUX</td>
                                <td className="bg-light-success text-center fw-bold">{formatPrice(totals.total_entree)}</td>
                                <td className="bg-light-danger text-center fw-bold">{formatPrice(totals.total_sortie)}</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td className="text-center fw-bold">SOLDE</td>
                                <td colSpan={2} className="text-center bg-light-info fw-bold">
                                    {formatPrice(totals.total_entree - totals.total_sortie)}
                                </td>
                            </tr>
                        </tbody>
                    </Table>

                </CardBody>
            </div>
        </Card>
    );
};

export const deleteCaisse = async ({ id }: { id: number }, onSuccess: () => void) => {
    const Token = JSON.parse(localStorage.getItem("login")!);

    axios.post(`${URL_API}/caisse/destroy/${id}`, {}, {
        headers: {
            Authorization: `Bearer ${Token}`
        }
    }).then(response => {

        if (response.data.success) {
            toast.warning("Élément Supprimer avec succès")
            onSuccess();
        }

    }).catch(error => {
        if (error.response.status === 404) {
            toast.info(error.response.data.message)
        }
        if (error.response.status === 500) {
            toast.info(error.response.data.message)
        }
    })

}


type Mouvement = {
  id: number;
  date_mouvement: string;
  type: "Entrée" | "Sortie";
  montant: number;
};

type Props = {
  data: Mouvement[];
};

const moisNoms = [
  "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
  "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
];

const colorStyle = {
  entree: { color: "green", fontWeight: "bold" },
  sortie: { color: "red", fontWeight: "bold" }
};

export const CaisseSummary: React.FC<Props> = ({ data }) => {
  const groupedData: { [year: string]: { [month: string]: Mouvement[] } } = {};

  data.forEach((item) => {
    const date = new Date(item.date_mouvement);
    const year = date.getFullYear();
    const month = date.getMonth();

    if (!groupedData[year]) groupedData[year] = {};
    if (!groupedData[year][month]) groupedData[year][month] = [];
    groupedData[year][month].push(item);
  });

  const getTotal = (items: Mouvement[], type: "Entrée" | "Sortie") =>
    items.filter(i => i.type === type).reduce((sum, i) => Number(sum) + Number(i.montant), 0);

  const renderTitle = (label: string, entree: number, sortie: number) =>
  `${label} : Entrée ${entree.toLocaleString("fr-FR")} GNF | Sortie ${sortie.toLocaleString("fr-FR")} GNF`;

  return (
    <Accordion atomic>
      {Object.keys(groupedData).sort((a, b) => Number(b) - Number(a)).map(year => {
        const allItems = Object.values(groupedData[year]).flat();
        const totalEntree = getTotal(allItems, "Entrée");
        const totalSortie = getTotal(allItems, "Sortie");

        return (
          <AccordionItem key={year} title={renderTitle(`${year}`, totalEntree, totalSortie)}>
            <Accordion atomic>
              {Object.keys(groupedData[year]).sort((a, b) => Number(a) - Number(b)).map(monthKey => {
                const month = parseInt(monthKey);
                const monthItems = groupedData[year][monthKey];
                const totalEntreeMonth = getTotal(monthItems, "Entrée");
                const totalSortieMonth = getTotal(monthItems, "Sortie");

                return (
                  <AccordionItem
                        key={`${year}-${month}`}
                        title={renderTitle(moisNoms[month], totalEntreeMonth, totalSortieMonth)} children={undefined}                  />
                );
              })}
            </Accordion>
          </AccordionItem>
        );
      })}
    </Accordion>
  );
};

